import { get } from "../Config";

export function GetPointHistory({ params }) {
  return get({ url: "/api/impact/v1/employee/pointHistory", params });
}
